import { FilterPreferenceRecognizedLists } from '../../../../../../services/modules/userContextPreferences/userContextPreferences.types';

export interface UseDynamicOptionsSelectorsCreatorProps {
  list?: FilterPreferenceRecognizedLists;
}

export enum DynamicOptionsSelectorsCreatorActionTypes {
  RESET_FILTERS = 'resetFiltersOfCreator',
  CLEAR_FILTERS = 'clearFiltersOfCreator',
  RESET_TO_DEFAULT_VALUES = 'resetToDefaultValues',
}
